module.exports = __webpack_public_path__ + "img/img66.5cf84050.svg";